import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { SearchableSelect } from '@shared/components';
import { fetchPlans } from '../services/plans';
import type { PlanProduct } from '../types/plan.types';

interface Props {
    value: PlanProduct | null;
    onChange: (next: PlanProduct | null) => void;
    excludeIds?: string[];
    disabled?: boolean;
    id?: string;
}

export function PlanCombobox({ value, onChange, excludeIds = [], disabled = false, id }: Props) {
    // SearchableSelect owns the debounce and emits only settled terms via onSearchChange.
    const [term, setTerm] = React.useState('');
    const { data, isFetching } = useQuery({
        queryKey: ['smr-admin', 'plan-search', 'active', term],
        queryFn: () => fetchPlans({ search: term, status: 'active', per_page: 20 }),
    });

    return (
        <SearchableSelect<PlanProduct>
            options={(data?.data ?? []) as PlanProduct[]}
            value={value}
            onChange={onChange}
            getOptionValue={(o) => o.id}
            getOptionLabel={(o) => o.name}
            onSearchChange={setTerm}
            loading={isFetching}
            excludeValues={excludeIds}
            disabled={disabled}
            id={id}
            placeholder="Search active plans…"
            emptyLabel="No active plans match."
        />
    );
}
